export default __webpack_public_path__ + "coralfish_camera.461c63ac.png";